import { AxiosResponse } from 'axios';
import { get } from './apiUtil';
import { PhotoDayBody } from '../model/photo-day-body';

export async function importPhotoDayFile(eventId: string): Promise<PhotoDayBody> {
    return new Promise((resolve, reject) => {
      get(`/api/eaus/v1/photoDay/importPhotoDayFile/${eventId}`)
        .then((response: AxiosResponse) => resolve(response.data as PhotoDayBody))
        .catch((e) => reject(e));
    });
  }

